import React from "react"
import { Col, Row } from "react-bootstrap"
import CardRow from "./CardRow"
import TestCardProps from "./TestCardProps"
import AccordionCard from "./AccordionCard"
import ServiceDetails from "../../../../api/OrderResults/OrderResultModel/ServiceDetails"
import FormatDate from "../../../../formatters/FormatDate"

type TestingResult = {
  testingText: string,
  testingDate: string | null,
  testingStatus: string | null,
  resultStatusCode?: string,
  testingClassName?: string
}
function getTestingResult(data: ServiceDetails, isCovid: boolean): TestingResult {
  let result: TestingResult = {testingText: "", testingStatus: "", testingDate: ""}
  if (data.ReleaseStatus) {
    if (data.ReleaseStatus.Code === "MCOMP" || data.ReleaseStatus.Code === "MPEND" || data.ReleaseStatus.Code === "MCREL") {
        result.testingText = "Laboratory Testing Complete "
        result.testingDate = FormatDate(data.LabReportDate)
        result.testingStatus = ""
    } else if (data.ReleaseStatus.Code === "LCOMP" || data.ReleaseStatus.Code === "LCREL" || data.ReleaseStatus.Code === "PCOMP" || data.ReleaseStatus.Code === "PCREL") {
      result.testingText = ""
      result.resultStatusCode = data.ReleaseStatus.Code
      result.testingDate = FormatDate(data.LabReportDate)
      result.testingStatus = ""
      if (data.ReleaseStatus.Code === "LCREL") {
        result.testingStatus = data.LabResultDescription
      }
    }
  }
  if (isCovid) {
    result.testingStatus = data.LabResultDescription
  }
  result.testingClassName = (result.testingStatus === '(Negative)' || result.resultStatusCode === 'LCOMP' || result.resultStatusCode === 'LCREL' || result.resultStatusCode === 'PCOMP'|| result.resultStatusCode === 'PCREL' || isCovid) ? "black-text" : "red-text"
  return result
}

export default function TestingCard(props: TestCardProps) {
  const { data, isCovid } = props
  const testingResult = getTestingResult(data, !!isCovid)
  const title = <Row>
    <Col xs={5} sm={3}>TESTING</Col>
    <Col xs={3} sm={5}>
      {testingResult.testingText}&nbsp;
      <span className={testingResult.testingClassName}>{testingResult.testingStatus}</span>
    </Col>
    <Col xs={4} sm={4}>{testingResult.testingDate}</Col>
  </Row>
  return (
    <AccordionCard eventKey="testing" title={title}>
      <CardRow title="LABORATORY" value={data.LaboratoryVendorName}/>
      <CardRow title="LAB ACCOUNT" value={data.LabAccountNumber}/>
      <CardRow title="PANEL" value={data.Panel.Description}/>
      <CardRow title="ACCESSION NUMBER" value={data.LabAccessionNumber}/>
      <CardRow title="LAB RECEIVED DATE" value={data.LabReceivedDate} date/>
      <CardRow title="LAB RECEIVED TIME" value={data.LabReceivedDate} time/>
      <CardRow title="LAB REPORT DATE" value={data.LabReportDate} date/>
      <CardRow title="LAB REPORT TIME" value={data.LabReportDate} time/>
      {isCovid && <div><label>Laboratory Note:</label><p>{data.ClinicalLabNotes}</p></div>}
    </AccordionCard>
  )
}
